import { CarouselSection } from './../carousel/CarouselSection';
import { register } from './../ShopifySection';
import * as ResponsiveSizes from './../../../settings/Responsive';

const CONTAINER_SELECTOR = '[data-testimonials]';
const CAROUSEL_SELECTOR = '[data-testimonials-carousel]';

class TestimonialCarousel extends CarouselSection {
  constructor(container) {
    super(container);
    this.carouselSelector = container.find(CAROUSEL_SELECTOR);

    this.slick = this.initCarousel(this.carouselSelector);
  }

  optionOverrides() {
    return {
      arrows: false,
      dots: true,
      responsive: [
        {
          breakpoint: ResponsiveSizes.medium-1,
          settings: { 
            arrows: true,
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
    }
  }
}

register(CONTAINER_SELECTOR, TestimonialCarousel);